type Props = React.ImgHTMLAttributes<HTMLImageElement>;

export function ChorganiserLogo(props: Props) {
  return <img src="/logo.webp" alt="Chorganiser Logo" {...props} />;
}
